// extracted by mini-css-extract-plugin
export default {"button":"file-upload-button_button__pDayz","input":"file-upload-button_input__Z+UPO"};